import { Container } from '@luminalearning/components';
import { Qualifications } from 'src/types';

type Props = {
    /** Product Qualification Name */
    productQualificationName: string;
    /** Product Logo */
    productLogo: React.ReactElement;
    /** Product color scheme */
    productColorTheme: string;
    /** Products under each qualification */
    products: Array<Qualifications>
};

const ProductCard = (props: Props) => {
    const {
        productQualificationName,
        productLogo,
        products,
        productColorTheme,
    } = props;
    const qualificationHeadingStyle = {
        color: productColorTheme,
    };
    return (
        <Container className='p-0'>
            <div className='flex justify-center py-4 border-card-normal border-b-1.5 border-solid'>
                {productLogo}
            </div>
            <div className='pt-4 pb-7 pl-6'>
                <div className='font-bold text-2xl' style={qualificationHeadingStyle}>{productQualificationName}</div>
                {products.map((product: any, index) => (
                    <div className='font-normal text-base py-1' key={index}>{product.name}</div>
                ))}
            </div>
        </Container>
    );
};

export default ProductCard;